// extracted by mini-css-extract-plugin
module.exports =  {"button":"TextToSpeech-spdU__button"};